import { render, staticRenderFns } from "./CustomFieldsTable.vue?vue&type=template&id=e6c56bbe&scoped=true&"
import script from "./CustomFieldsTable.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsTable.vue?vue&type=style&index=0&id=e6c56bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c56bbe",
  null
  
)

export default component.exports